import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/flight.png'


const _hoisted_1 = { class: "ws-textbox" }
const _hoisted_2 = { class: "airport-name text-dark" }
const _hoisted_3 = { class: "flight-time-der" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "frame-flight-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "No image"
  })
], -1)
const _hoisted_6 = { class: "flight-status" }
const _hoisted_7 = { class: "text-dark" }
const _hoisted_8 = { class: "flight-status-text" }
const _hoisted_9 = { class: "airport-name text-dark" }
const _hoisted_10 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_StyledSFSFlightInfo = _resolveComponent("StyledSFSFlightInfo")!

  return (_openBlock(), _createBlock(_component_StyledSFSFlightInfo, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.flight)
          ? (_openBlock(), _createBlock(_component_el_row, {
              key: 0,
              class: "block-item-flight"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_container, { class: "flightinfo text-center my-3" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, {
                      span: 8,
                      class: "p-0"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, _toDisplayString(_ctx.groundHandlerMessage?.homepage_new.SFS_LANG_ROW_1), 1),
                        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.flight.dep), 1),
                        _createElementVNode("div", _hoisted_3, [
                          _createTextVNode(_toDisplayString(_ctx.$filters.formatDate(_ctx.flight.std, 'D MMM')) + " ", 1),
                          _createElementVNode("div", {
                            style: _normalizeStyle(_ctx.flight.etd ? 'text-decoration: line-through' : '')
                          }, _toDisplayString(_ctx.$filters.formatDate(_ctx.flight.std, 'HH:mm')), 5),
                          (_ctx.flight.etd)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$filters.formatDate(_ctx.flight.etd, 'HH:mm')), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, {
                      span: 8,
                      class: "p-0"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, _toDisplayString(!_ctx.flight.carrier ? _ctx.flight.flight_number : _ctx.flight.carrier + _ctx.flight.flight_no), 1),
                        _hoisted_5,
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.groundHandlerMessage?.homepage_new.SFS_LANG_ROW_3) + ":", 1),
                          _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.statusFlight), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, {
                      span: 8,
                      class: "p-0"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, _toDisplayString(_ctx.groundHandlerMessage?.homepage_new.SFS_LANG_ROW_2), 1),
                        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.flight.div), 1),
                        _createElementVNode("div", null, [
                          _createTextVNode(_toDisplayString(_ctx.$filters.formatDate(_ctx.flight.sta, 'D MMM')) + " ", 1),
                          _createElementVNode("div", {
                            style: _normalizeStyle(_ctx.flight.eta ? 'text-decoration: line-through' : '')
                          }, _toDisplayString(_ctx.$filters.formatDate(_ctx.flight.sta, 'HH:mm')), 5),
                          (_ctx.flight.eta)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$filters.formatDate(_ctx.flight.eta, 'HH:mm')), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}